// extracted by mini-css-extract-plugin
export default {"root":"SearchControls_root__rB2ax"};